import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AccountBankingInfo } from "../../graphql/graphql_banking/legder/types/AccountBankingInfo";

export const ledgerSlice = createSlice({
  name: "ledger",
  initialState: {
    myAccount: {} as AccountBankingInfo,
    allAccount: [] as (AccountBankingInfo | null)[],
  },
  reducers: {
    setMyAccount: (state, action: PayloadAction<AccountBankingInfo>) => {
      state.myAccount = action.payload;
    },
    setAllAccount: (
      state,
      action: PayloadAction<(AccountBankingInfo | null)[]>,
    ) => {
      state.allAccount = action.payload;
    },
  },
});

export const { setMyAccount, setAllAccount } = ledgerSlice.actions;

export default ledgerSlice.reducer;
